/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=["backward-diagonal","cross","diagonal-cross","forward-diagonal","horizontal","none","solid","vertical"];export{o as fillStyles};
